import { Component, OnInit, ViewChild, ViewEncapsulation, ElementRef } from '@angular/core'
import { MdDialogRef } from '@angular/material'

import { ImageCropperComponent, CropperSettings } from 'ng2-img-cropper'

@Component({
  selector: 'cm-crop-dialog',
  templateUrl: './crop-dialog.component.html',
  styleUrls: ['./crop-dialog.component.css'],
})
export class CropDialogComponent implements OnInit {

  public title: string
  public image: File

  public data: any = {}

  @ViewChild('cropper')
  cropper: ImageCropperComponent

  public cropperSettings: CropperSettings

  constructor(private dialogRef: MdDialogRef<CropDialogComponent>,
    private el: ElementRef) {
    this.cropperSettings = new CropperSettings()
    this.cropperSettings.noFileInput = true
    this.cropperSettings.dynamicSizing = true
    this.cropperSettings.croppedWidth = 320
    this.cropperSettings.croppedHeight = 320
    this.cropperSettings.cropperClass = 'cropper-canvas'
  }

  ngOnInit() {
    this.el.nativeElement.parentElement.style.maxWidth = '100vw'
    this.el.nativeElement.parentElement.style.padding = '0'

    const reader: FileReader = new FileReader()
    reader.onload = (e: any) => {
      const image = new Image()
      image.src = e.target.result
      this.cropper.setImage(image)
    }

    reader.readAsDataURL(this.image)
  }

  crop() {
    this.dialogRef.close(this.data.image)
  }

  cancel() {
    this.dialogRef.close(null)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/dialog/crop-dialog/crop-dialog.component.ts